import { render, staticRenderFns } from "./CustomerCorporateBatchOrderAdjustment.vue?vue&type=template&id=110a1216&scoped=true"
import script from "./CustomerCorporateBatchOrderAdjustment.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateBatchOrderAdjustment.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateBatchOrderAdjustment.vue?vue&type=style&index=0&id=110a1216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a1216",
  null
  
)

export default component.exports